import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const RequireAdmin = ({ children }: { children: React.ReactNode }) => {
  const { loading, session, isAdmin } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Загрузка…</div>;
  if (!session) return <Navigate to="/auth" replace />;
  if (!isAdmin) {
    return (
      <main className="min-h-screen flex flex-col items-center justify-center text-center px-4 gap-3">
        <h1 className="font-display text-2xl">Нет доступа</h1>
        <p className="text-muted-foreground max-w-md">
          Этот раздел доступен только администраторам. Попросите администратора назначить вам роль <code>admin</code> в таблице user_roles.
        </p>
      </main>
    );
  }
  return <>{children}</>;
};

export default RequireAdmin;
